import * as React from "react";
import { AlphaId } from "../types";
import { observer } from "mobx-react-lite";
import { Tag } from "antd";

type Props = {
    alphaId: AlphaId | string;
};

const AlphaIdLabel: React.FC<Props> = ({ alphaId }) => {
    const value =
        typeof alphaId === "string"
            ? alphaId
            : `${alphaId.prefix}-${alphaId.index}`;

    // TODO: Get the color from a theme or configuration
    return <Tag color="#273C75">{value}</Tag>;
};

export default observer(AlphaIdLabel);
